import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';


import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';
//import parse from 'html-react-parser';
//import { Helmet } from 'react-helmet';

import * as Hosts from '../../../Hosts';
import { reqGET, repo_img_link, content_language, set_language, translate } from '../../../Utils';

import Loader from '../../../loader';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
// import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { language } from '../WEBContent/Language';

import AssecImage from "../ASSEC_Image/Image"

export default function TouristicOfferCards(props) {
    const { pathname } = useLocation();

    const [, set_dados] = useState(null);
    const dados = useRef(null);
    const list_distritos_ativos = useRef([]);
    const list_concelhos_ativos = useRef([]);
    const list_distritos = useRef([]);
    const list_concelhos = useRef([]);

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1');

    const data_interface = {
        id: '',
        info: {},
        content: {}
    }
    const [content_parent, set_content_parent] = useState(null);
    const [list_content, set_list_content] = useState([]);

    useEffect(() => {

        (async () => {
            const get_distritos = async () => {
        
                await reqGET(`${Hosts.SIMCore_API}/countries/pt/districts`)
                    .then(res => {
        
                        let aux = []
                        if(res.data !== undefined && res.data.length > 0) {

                            set_dados(list_distritos.current = res.data);

                            res.data.forEach(el => {
                                // if(el.codgrupo === codgrupo) {
                                    aux.push(el)

                                    get_concelhos(el.distrito_dt)
                                // }
                            })
                        }
        
                    })
                    .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
            }
        
            const get_concelhos = async (coddistrito) => {

                let dist_aux = list_distritos.current.filter(el => el.distrito_dt === coddistrito)
                if(dist_aux !== undefined && dist_aux.length > 0) {
                    await reqGET(`${Hosts.SIMCore_API}/countries/pt/citiesofdistrict/${dist_aux[0].langpt_dt}`)
                        .then(res => {
        
                            let result = list_concelhos.current
                            if(res.data !== undefined && res.data.length > 0) {
                                res.data.forEach(el => {
                                    result.push(el)
                                })
                                set_dados(list_concelhos.current = result)
                            }
            
                        })
                        .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
                }
            }

            await get_distritos()

            /* console.log('aaaa') */
            if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
                set_lang('pt')
                set_language('pt')
                set_lang_id('1')
            }
            else {
                set_lang(localStorage.getItem('lang'))
                content_language.forEach(el => {
                    if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                    }
                })
            }

            try {
                let getInfoList = async () => {

                    await reqGET(`${Hosts.SIMCore_API}/web/structure/${Hosts.companycode}/1`)
                        .then(res => {
                            if(res.data.length > 0) {
                                res.data.forEach((v) => {
                                    if (v.info.principal === true) {
                                        //set_dados(dados.current = v);

                                        v.content.childs.forEach((el) => {
                                            
                                            if(el.id_content === '' && ('/' + el.link === pathname)) {
                                                if(el['parent'] !== undefined) {
                                                    console.log(el['parent'])
                                                }
                                            }

                                            if(el['children'] !== undefined && el['children'].length > 0) {
                                                el['children'].forEach(async (el_c) => {
                                                    if(el_c.id_content === '' && ('/' + el_c.link === pathname)) {
                                                        if(el_c['parent'] !== undefined && el_c['parent'] !== null && el_c['parent'] !== '') {

                                                            await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${el_c['parent']}`)
                                                                .then(res => { 
                                                                    if(res.data.length > 0) {
                                                
                                                                        var hoje = new Date();
                                                                        let status = 0
                                                                        if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                                                                            var date_p = new Date(res.data[0].info.date.published);
                                                
                                                                            status = 1
                                                                            if(hoje >= date_p) 
                                                                                status = 2
                                                                        }
                                                
                                                                        if(status !== 2) {
                                                                            res.data[0].content = {text: ''}
                                                
                                                                            set_content_parent(res.data[0])   
                                                                        }
                                                                        else {
                                                                            set_content_parent(res.data[0]) 
                                                                        }
                                                                    }
                                                                })
                                                                .catch(erro => console.log('ERROR', erro))

                                                        }
                                                    }
                                                })
                                            }

                                        })
                                        
                                    }
                                })
                            }
                            else {
                                return []
                            }

                        })
                        .catch(erro => console.log('ERROR', erro))

                    let res = await reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/tourist_entertainment/name`)
                    if (res.data.length > 0) {

                        var hoje = new Date();
                        let aux = []
                        let aux_d = []
                        let aux_c = []

                        for await (let v of res.data) {
                            if(v.info.date.published !== undefined && v.info.date.published !== '') {
                                var date_p = new Date(v.info.date.published);
                    
                                if(hoje >= date_p) {
                                    aux.push(v)

                                    if(v?.info?.distrito !== undefined && v?.info?.distrito !== '') {
                                        if(aux_d.filter(el => el === v?.info?.distrito).length === 0) {
                                            aux_d.push({
                                                id: v.info.distrito,
                                                name: get_distrito_by_id(v.info.distrito)
                                            })
                                        }
                                    }
                                    if(v?.info?.concelho !== undefined && v?.info?.concelho !== '') {
                                        if(aux_c.filter(el => el.id === v?.info?.concelho).length === 0) {
                                            aux_c.push({
                                                id: v.info.concelho,
                                                name: get_concelho_by_id(v.info.concelho)
                                            })
                                        }
                                    }

                                }
                            }
                        }

                        if(aux_d.length > 0)
                            aux_d.sort((a, b) => a.name.localeCompare(b.name))
                        if(aux_c.length > 0)
                            aux_c.sort((a, b) => a.name.localeCompare(b.name))

                        set_dados(list_distritos_ativos.current = aux_d)
                        set_dados(list_concelhos_ativos.current = aux_c)
                        set_list_content(aux)
                        //set_list_content(res.data)
                        //console.log('NOTICIAS', res.data)
            
                        setLoading(false)
                    }
                    else {
                        set_dados(list_distritos_ativos.current = [])
                        set_dados(list_concelhos_ativos.current = [])
                        set_list_content([])
                        //set_list_content(res.data)
                        //console.log('NOTICIAS', res.data)
            
                        setLoading(false)
                    }
                }
                getInfoList()

            } catch {
                console.log('nada')

                return
            }
        })()

    }, [pathname]);

    const get_distrito_by_id = (coddistrito) => {

        let result = ''
        let aux_d = list_distritos.current.filter(e => e.distrito_dt === coddistrito)
        if(aux_d !== undefined && aux_d.length > 0) {
            result = aux_d[0].langpt_dt
        }
        return result

    }  

    const get_concelho_by_id = (codconcelho) => {

        let result = ''
        let aux_c = list_concelhos.current.filter(e => e.concelho_cc === codconcelho)
        if(aux_c !== undefined && aux_c.length > 0) {
            result = aux_c[0].langpt_cc
        }
        return result

    }   

    const change_filter = (type, id) => {

        let btns = document.getElementsByClassName('btn-filter')
        for (let item of btns) {
            item.classList.remove('active')
        }

        if(id === 'all') {
            document.getElementById('btn-all').classList.add('active')

            let list_all = document.getElementsByClassName('div-all')
            for (let item of list_all) {
                item.classList.remove('d-none')
            }
        }
        else {
            if(id !== '') {
                document.getElementById('btn-' + id).classList.add('active')

                let list_all = document.getElementsByClassName('div-all')
                for (let item of list_all) {
                    item.classList.add('d-none')
                }
                let list = document.getElementsByClassName(type + '-' + id)
                for (let item of list) {
                    item.classList.remove('d-none')
                }
                // document.getElementsByClassName(type + '-' + id).forEach((element) => element.classList.add("teststyle"))
                // document.getElementsByClassName(type + '-' + id).classList.add("d-none")
            }
        }

    }

    return (isloading ?

		<Loader />
		
		:
        <>
            <Navbar />
            <Breadcrumb />
            <main className="touristic-cards">
                <section id="touristic-cards" className="content-body">

                    <div className="container-fluid bg-light py-5">
                        <div className="row">
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <h3 className="titulo-primario">
                                            <span>{language[lang].touristic_offer}</span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container my-5">
                        <div className="row">
                            <div className="col-12">
                                {
                                content_parent !== undefined && content_parent !== null ?
                                    <div className="row">
                                        <div className="div-content col-12 mb-3 mb-md-5">
                                            <h2 className="titulo-primario">
                                                {/*content_parent['content'][0] !== undefined && content_parent['content'][0]['title'] !== undefined && content_parent.content[0].title !== '' ? content_parent.content[0].title : 'Parceiros'*/}
                                                {(lang === 'pt' || content_parent['content'][0].language === undefined ? content_parent['content'][0].title : (content_parent['content'][0].language[lang_id] === undefined || content_parent['content'][0].language[lang_id].title === undefined || content_parent['content'][0].language[lang_id].title === '' ? content_parent['content'][0].title : content_parent['content'][0].language[lang_id].title))}
                                            </h2>
                                            <h2 className={content_parent['content'][0] !== undefined && content_parent['content'][0]['subtitle'] !== undefined && content_parent.content[0].subtitle !== '' ? "titulo-secundario" : "d-none"}>
                                                {/*content_parent['content'][0] !== undefined && content_parent['content'][0]['subtitle'] !== undefined && content_parent.content[0].subtitle !== '' ? content_parent.content[0].subtitle : ''*/}
                                                {(lang === 'pt' || content_parent['content'][0].language === undefined ? content_parent['content'][0].subtitle : (content_parent['content'][0].language[lang_id] === undefined || content_parent['content'][0].language[lang_id].subtitle === undefined || content_parent['content'][0].language[lang_id].subtitle === '' ? content_parent['content'][0].subtitle : content_parent['content'][0].language[lang_id].subtitle))}
                                            </h2>
                                            <div className={"div-text"}>
                                                {/*content_parent['content'][0] !== undefined && content_parent['content'][0]['text'] !== undefined && content_parent.content[0].text !== '' ? ReactHtmlParser(content_parent.content[0].text) : ''*/}
                                                {ReactHtmlParser(lang === 'pt' || content_parent['content'][0].language === undefined ? content_parent['content'][0].text : (content_parent['content'][0].language[lang_id] === undefined || content_parent['content'][0].language[lang_id].text === undefined || content_parent['content'][0].language[lang_id].text === '' ? content_parent['content'][0].text : content_parent['content'][0].language[lang_id].text))}
                                            </div>
                                        </div>
                                    </div>
                                :
                                    null
                                }

                                {
                                list_concelhos_ativos.current !== undefined && list_concelhos_ativos.current !== null && list_concelhos_ativos.current.length >0 ?
                                    <div className="row">
                                        <div className="div-filter col-12 mb-3 mb-md-5">
                                            <button type="button" id="btn-all" className='btn btn-secondary btn-filter mr-1 active' onClick={() => change_filter('c', 'all')}>{language[lang].see_it_all}</button>
                                            {
                                            list_concelhos_ativos.current.map((el_ca, k_ca) => {
                                                return (
                                                    <button key={k_ca} type="button" id={"btn-" + el_ca.id} className='btn btn-secondary btn-filter mr-1' onClick={() => change_filter('c', el_ca.id)}>{el_ca.name}</button>
                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                :
                                    null
                                }

                                <div className="row">
                                    {
                                    list_content.map((content) => {
                                        return (
                                            content.content.map((el, k) => {  
                                                return (
                                                    <div key={k} className={"col-12 col-sm-6 col-md-4 col-lg-4 mb-5 div-all" + (content?.info?.concelho !== undefined ? ' d-' + content.info.distrito : '') + (content?.info?.concelho !== undefined ? ' c-' + content.info.concelho : '')}>
                                                        <div className="card touristic-item hover-animate border-0">
                                                            <a href={'./touristic/' + (content.info['slug'] !== undefined && content.info.slug !== '' ? content.info.slug : content.id)} title={translate(el.title, lang)}>
                                                                {
                                                                el['media'] !== undefined && el['media']['image'] !== undefined && el['media']['image'].length > 0 ?
                                                                    <div className="touristic-img"> 
                                                                        <AssecImage 
                                                                            linkImage={el['media']['image'][0]['link']}
                                                                            width="400"
                                                                            height="300"
                                                                            fit='crop'
                                                                            type='img'
                                                                            sClass="img-fluid rounded mb-2" 
                                                                            alt={el['media']['image'][0]['name']}
                                                                        />
                                                                        {/*<img src={el['media']['image'][0]['link']} className="img-fluid" alt={el['media']['image'][0]['name']} />*/}
                                                                    </div>
                                                                :
                                                                    <div className="touristic-img"> 
                                                                        <AssecImage 
                                                                            linkImage={repo_img_link('nophoto.webp')}
                                                                            width="450"
                                                                            height="300"
                                                                            fit='crop'
                                                                            type='img'
                                                                            sClass="img-fluid rounded mb-2" 
                                                                            alt="no_photo"
                                                                        />
                                                                    </div>
                                                                }
                                                                <div className="card-body pb-3 bg-light rounded">
                                                                    <div className="card-bar mb-3"></div>
                                                                    <div className="card-title">
                                                                        {translate(el.title, lang)}
                                                                    </div>
                                                                    <div className="card-text limit-5-lines">
                                                                        {ReactHtmlParser(translate(el.text, lang))}
                                                                    </div>
                                                                </div>
                                                            </a>
                                                            <div className="card-footer text-center d-none">
                                                                <a className="btn btn-text" href={'./touristic/' + content.id} title={language[lang].see_tourist_entertainment}>{language[lang].see_tourist_entertainment}<i className="bi bi-chevron-right"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                )
                                            })
                                        )
                                    })
                                    }
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}